import React, { useState, useEffect } from 'react'
import { collection, addDoc, Timestamp, arrayUnion, updateDoc, doc, addField } from "firebase/firestore";
import { db } from '../services/firebase';
import { sendEmailAsync } from '../services/sendEmail';

import { Section, Icon, VStack, Title2, Body, Space, HStack, Button, Footnote, Subhead, Container, Label, Input } from '@themeable/react'

function SubscribeBanner() {

  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');

  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const [formSuccess, setFormSuccess] = useState(false);


  const sendSubscribeInfo = async () => {
    setEmailError('')
    setNameError('')
    const result = await sendEmailAsync({
      email: email,
      message: 'User wants to subscribe to RSN',
      name: name,
    });
    console.log(result)
    if (result.status === 'error') {
      // Set errors for each field
      if (result.fields.email) setEmailError(result.fields.email);
      if (result.fields.message) setMessageError(result.fields.message);
      if (result.fields.name) setNameError(result.fields.name);
    } else {
      // Handle success (e.g., show success message or clear form)
      setFormSuccess(true);
    }
  };



  return (
    <>

      <VStack style={{
        background: 'rgb(var(--color-background-flat))', zIndex: '3', position: 'relative',
      }}>
        <Section>
          <HStack gridExpanded={[1, 1]} gridCompact={[1]} gridMedium={[1, 1]}>

            {/* Left column */}
            <VStack align='middle' height='fill'>

              <Title2>Wanna Become a Certified Mom?</Title2>
              <Body>I'll send you my best tips and tricks to help you achieve certified mom status.</Body>
              <Space.Content />
              <Space.Content />
              {formSuccess ? (<>
                <Subhead>
                  Thanks for subscribing!
                </Subhead>
              </>) : (<>
                <HStack>
                  <Label error={nameError !== ''} helperText={nameError} label='Name'>
                    <Container>
                      <Input value={name} onChange={((e) => { setName(e.target.value) })} />
                    </Container>
                  </Label>
                </HStack>
                <Label error={emailError !== ''} helperText={emailError} label='Email'>
                  <Container>
                    <Input value={email} onChange={((e) => { setEmail(e.target.value) })} />
                  </Container>
                </Label>
                <Button title='Subscribe' variant='primary' onClick={sendSubscribeInfo} />
              </>)}
            </VStack>

            {/* Right column (image) */}
            <VStack align='right bottom' showOn='medium expanded' style={{
              marginTop: '-80px',
              marginBottom: 'calc(var(--space-v-section) * -1)',
            }}>
              <VStack height='hug' width='hug'>
                <img src='../assets/jessicakounter-nurse-redeeming-special-needs.png'
                  style={{ width: '300px' }}
                />
              </VStack>
            </VStack>

          </HStack>
        </Section>
      </VStack>
    </>
  )
}

export { SubscribeBanner }
